import React from 'react';
import Nav2 from '../components/Nav2/Nav2'
import CardsUser from '../components/UserPage/CardsUser';
import Footer from '../components/Footer/Footer'
import MultiSelect from '../components/SearchBar/MultiSelect';


const UserPage = () => {
    return (
        <div>
            <Nav2 />
            <MultiSelect />
            <CardsUser />
            <Footer />
        </div>
    )
}

export default UserPage;